import { Colors } from './Colors';

export const PaletteColors = {
  primary: {
    main: Colors.PRIMARY_BLUE,
  },
  secondary: {
    main: Colors.SECONDARY_MEDIUM,
  },
};
